


export class ConnectErrorSocketException extends Error {

}
